import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const BrandPage = lazy(() =>
  import('../../pages/settings/brand/BrandPage').then((m) => ({
    default: m.BrandPage,
  })),
);

export const Route = createFileRoute('/settings/brand')({
  component: () => (
    <Suspense fallback={<Spinner style={{ position: 'absolute', top: '25%', left: '50%' }} />}>
      <BrandPage />
    </Suspense>
  ),
});
